/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Installments/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromFormat from 'Data/format.js'
import Completed from './Completed/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Installments({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/PaymentsTreatmentPlan/Content/TreatmentPayments/Content/Content/SetupPayment/Breakdown/PayerInfo/Installment/Content/Installments"
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let payerDataInstallmentTotalValueData = fromData.useDataFormat({ viewPath,
context: 'payer',
path: 'data.installment_total',
format: fromFormat.numberMoney,
})
  return (<React.Fragment
>
<button
  data-testid="Installments.Horizontal"
  data-view-path={viewPath}
 onClick={flow.has(fromFlow.normalizePath(viewPath, '../Expandable/Content')) ? () => setFlowTo(fromFlow.normalizePath(viewPath, '../Expandable/No')) : () => setFlowTo(fromFlow.normalizePath(viewPath, '../Expandable/Content'))}
 style={{'--pb-1-Z2sq4Ui': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Installments.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral600}
 text="Installments"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginLeft={dtSpaceXxs}
 color={dtColorsNeutral600}
 text={flow.has(fromFlow.normalizePath(viewPath, '../Expandable/Content')) ? "-" : flow.has(fromFlow.normalizePath(viewPath, '../Expandable/No')) ? "+" : "+"}
/>
<Completed
  viewPath={`${viewPath}/Completed`}
/>
</div>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 data="payer.data.installment_total"
 format="/Data/format.js numberMoney"
 text={payerDataInstallmentTotalValueData}
/>
</button>
{children}
</React.Fragment>)
}